<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><a id="pix"> We have advanced by leaps to the Pacific, and left many a lesser Oregon and California unexplored behind us.</a></p></blockquote><a id="pix">
<blockquote><p class="right"><em>—The Maine Woods,</em><br/>
Henry David Thoreau</p></blockquote>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?45d29499